module.exports = __webpack_public_path__ + "static/assets/721b68b3daef0cdc09dd1c06bab83334.png";